import { render, staticRenderFns } from "./ViewEntryDiaryBook.vue?vue&type=template&id=23673868&scoped=true"
import script from "./ViewEntryDiaryBook.vue?vue&type=script&lang=js"
export * from "./ViewEntryDiaryBook.vue?vue&type=script&lang=js"
import style0 from "./ViewEntryDiaryBook.vue?vue&type=style&index=0&id=23673868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23673868",
  null
  
)

export default component.exports